import { render, staticRenderFns } from "./TheAppLoader.vue?vue&type=template&id=21618aff&"
import script from "./TheAppLoader.vue?vue&type=script&lang=js&"
export * from "./TheAppLoader.vue?vue&type=script&lang=js&"
import style0 from "./TheAppLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports